export function getRedirectUrl() {
  const env = process.env.NEXT_PUBLIC_ENV;
  switch (env) {
    case 'development':
      return 'https://dev-manager.martinsads.com.br/lobby';
    case 'staging':
      return 'https://hml-manager.martinsads.com.br/lobby';
    case 'production':
      return 'https://manager.martinsads.com.br/lobby';
    default:
      return 'https://dev-manager.martinsads.com.br/lobby';
  }
}
